import { FC } from 'react';
import { SharedPreviewConfiguration } from '../../../shared/preview-configuration';
import {
  SectionDivider,
  SectionPreview,
  SectionTitle,
} from '../../../shared/section-styles';
import { SectionDescription } from '../../../shared/section-styles';
import { PeoplePageDerivedSectionSources } from '../../people-page-section-sources';
import { PeoplePageSourceDerivedQuestionSectionComponentProps } from '../types';

interface Props extends PeoplePageSourceDerivedQuestionSectionComponentProps {
  onWrapperClick: () => void;
}
export const PeoplePageSourceDerivedQuestionSectionPromptPreview: FC<Props> = ({
  node,
  onWrapperClick,
}) => {
  const config = node.attrs.config;
  const configurationBarValue = {
    groupBy: config?.groupBy,
    generateAs: config?.generateAs,
  };

  return (
    <SectionPreview
      onClick={(event) => {
        event.stopPropagation();
        onWrapperClick();
      }}
    >
      <div>
        <SectionTitle>{node.attrs.title}</SectionTitle>
        <SectionDescription>{config.question}</SectionDescription>
      </div>
      <SharedPreviewConfiguration prompt={configurationBarValue} />
      <SectionDivider />
      <PeoplePageDerivedSectionSources sources={config.sourcePageTemplates} />
    </SectionPreview>
  );
};
